import { array, object, string, type InferType } from "yup"
import {
  OrganizationSchema,
  OwnOrgCreateSchema,
} from "../organizations/Organization"

export const UserDataSchema = object({
  created_at: string().required(),
  created_by: string().required(),
  email: string().required(),
  first_name: string(),
  id: string().required(),
  last_name: string(),
  // preferences: Json | null
  updated_at: string().defined(),
  updated_by: string().defined(),

  Organizations: array(OrganizationSchema).required(),
})

export type UserDataDto = InferType<typeof UserDataSchema>

export const UserNameMaxLength = 100 // VARCHAR(100) in the db
export const JoinOrgRequestOrgHintMaxLength = 200
export const JoinOrgRequestMessageMaxLength = 2000

const UserNameSchema = object({
  first_name: string().trim().required().max(UserNameMaxLength),
  last_name: string().trim().required().max(UserNameMaxLength),
})

/**
 * Self-service registration of a verified Cognito user, creating its own org.
 * Transferred from the FE to the BE. Id and email come from the token.
 */
export const RegisterUserSchema = UserNameSchema.shape({
  org: OwnOrgCreateSchema.required(),
})

/**
 * Self-service registration of a verified Cognito user, asking to join an
 * existing org. Customer support handles the request by hand.
 */
export const JoinOrgRequestSchema = UserNameSchema.shape({
  /** Name or other identification of the org to join, free text */
  org_hint: string().trim().required().max(JoinOrgRequestOrgHintMaxLength),
  message: string().trim().max(JoinOrgRequestMessageMaxLength).optional(),
})

export type RegisterUserDto = InferType<typeof RegisterUserSchema>
export type JoinOrgRequestDto = InferType<typeof JoinOrgRequestSchema>

/** Who registers: taken from the verified ID token, never from the request body. */
export type RegistrantDto = {
  /** Cognito `sub` */
  id: string
  email: string
}

export const DEFAULT_USER_ID = "00000000-0000-0000-0000-000000000000" // As of now, decision is that devices updates will not have their own user ID, but it is still required for create
